module.exports = __webpack_public_path__ + "img/service.f707dcb1.svg";